<template>
    <header>
        <nav>
            <div class="brand">
                <a href="/#/">
                    <img src="/images/logo-main2.jpg" alt="CoExCell Logo" class="logo-img">
                </a>
            </div>
            <div class="menu">
                <a :class="{'active': isActive('/')}" href="/#/">Home</a>
                <div class="nav-dropdown">
                    <a :class="{'active': isActive('/singleCell/list') || isActive('/singleCell/consensus')}" href="/#/singleCell/list" @click.prevent="singleCellMenuOpen = !singleCellMenuOpen">Single-Cell <i class="el-icon-arrow-down"></i></a>
                    <div class="dropdown-menu">
                        <a href="/#/singleCell/list" @click="singleCellMenuOpen = false">Per Dataset View</a>
                        <a href="/#/singleCell/consensus" @click="singleCellMenuOpen = false">Consensus Score</a>
                    </div>
                </div>
                <a :class="{'active': isActive('/spatial/list')}" href="/#/spatial/list">Spatial</a>
                <a :class="{'active': isActive('/gene/list')}" href="/#/gene/list">Gene</a>
                <a :class="{'active': isActive('/tutorial')}" href="/#/tutorial">Tutorial</a>
                <a :class="{'active': isActive('/download')}" href="/#/download">Download</a>
                <a :class="{'active': isActive('/about')}" href="/#/about">About</a>
                <a :class="{'active': isActive('/log')}" href="/#/log">Log</a>
            </div>
            <div class="brand" style="visibility:hidden;">
                <img src="/images/logo-main.png" alt="Logo" class="logo-img">
            </div>
        </nav>
    </header>
</template>

<script>


export default {
    name: "nav-header",

    data() {
        return {
            id: "",
            singleCellMenuOpen: false,
        };
    },

    computed: {
        curActive() {
            return this.$route.path;
        },
    },

    watch: {
        "$route.path"() {
            this.singleCellMenuOpen = false;
        },
    },

    methods: {
        isActive(path) {
            if (path === '/') {
                return this.curActive === '/';
            }
            // Allow prefix matching for sub-pages
            // e.g. /singleCell/list matches /singleCell/detail/...
            const sectionPrefix = path.endsWith('/list') ? path.replace('/list', '') : path;
            return this.curActive.startsWith(sectionPrefix);
        },
    },
};
</script>

<style scoped>
/* :root variables moved to common/base.less */

* {
    box-sizing: border-box;
}

a {
    text-decoration: none;
    color: inherit;
}

header {
    position: sticky;
    top: 0;
    z-index: 10;
    background: rgba(223, 228, 237, 0.9);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid var(--border);
}

nav {
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
}

.brand {
    font-family: 'Playfair Display', serif;
    font-size: 28px;
    font-weight: 700;
    color: var(--navy);
    letter-spacing: 0.2px;
    display: flex;
    align-items: center;
}

.logo-img {
    height: 65px;
    display: block;
}

.menu {
    display: flex;
    gap: 16px;
    font-weight: 600;
    color: var(--muted);
}

.nav-dropdown {
    position: relative;
}

.nav-dropdown > a {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 8px;
    min-width: 190px;
    padding: 8px;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 8px;
    box-shadow: 0 12px 28px rgba(14, 26, 40, .16);
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: opacity .15s ease, visibility .15s ease;
}

.nav-dropdown:hover .dropdown-menu,
.nav-dropdown:focus-within .dropdown-menu {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
}

/* Keep the hover path continuous across the small visual gap. */
.dropdown-menu::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 0;
    right: 0;
    height: 8px;
}

.dropdown-menu a {
    display: block;
    padding: 10px 12px;
    border-radius: 5px;
    white-space: nowrap;
    color: var(--navy);
    font-size: 14px;
}

.dropdown-menu a:hover {
    background: #eef4f8;
    color: var(--accent);
}

.btn {
    padding: 12px 20px;
    border-radius: 13px;
    font-weight: 700;
    border: 1px solid var(--accent);
    background: var(--accent);
    color: #0c1724;
    box-shadow: 0 12px 24px rgba(93, 135, 181, 0.22);
}

.ghost {
    background: transparent;
    color: var(--accent);
    border: 1px solid var(--accent);
    box-shadow: none;
}

.menu a.active {
    color: var(--accent);
    text-decoration: underline;
}

/* 添加字体链接 */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Playfair+Display:wght@600&display=swap');
</style>
